import React from 'react';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import CustomTranslation from './CustomTranslation';
import CustomCheckBox from './CustomCheckBox';
import TranslationAction from '../../Actions/TranslationAction';

class TranslationButton extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //set state
        this.state = {
            modalVisible: false,
            searchQuery: '',
            rememberChoice: false,
            searchPlaceholder: ''
        };
    }

    componentDidMount = async () => {
        TranslationAction.init();
        let searchPlaceholder = await TranslationAction.translate('KEY.Search');
        this.setState({ searchPlaceholder: searchPlaceholder });
    }

    handleClick = () => {
        if (typeof this.props.onFirstInteract === 'function') {
            this.props.onFirstInteract();
        }
        if (this.props.showTranslation) {
            this.props.onShowOriginal();
        } else if (this.props.savedLanguage) {
            this.props.onTranslate(this.props.savedLanguage, false);
        } else {
            this.setState({ searchQuery: '', modalVisible: true });
        }
    }

    handleLanguageSelect = (language) => {
        this.setState({ modalVisible: false });
        this.props.onTranslate(language, this.state.rememberChoice);
    }

    handleClose = () => {
        this.setState({ modalVisible: false, searchQuery: '', rememberChoice: false });
    }

    render = () => {

        //filter available languages by search query
        const filteredLanguages = (this.props.availableLanguages ?? []).filter((lang) =>
            lang.label.toLowerCase().includes(this.state.searchQuery.toLowerCase())
        );

        return (
            <>
                <div
                    className={'touchable'}
                    style={{ display: 'inline-flex', alignItems: 'center', padding: '0.2rem' }}
                    onClick={this.handleClick}
                >
                    {this.props.loading
                        ? <Spinner size={'sm'} animation={'border'} variant={'dark'} />
                        : <i
                            className={'las la-language'}
                            style={{ fontSize: '1.5rem', fontWeight: 900, color: this.props.showTranslation ? '#fdb019' : undefined }}
                        />
                    }
                </div>

                <Modal show={this.state.modalVisible} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title><CustomTranslation value={'KEY.Choose language'} /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Control
                            type={'text'}
                            autoCorrect={'off'}
                            placeholder={this.state.searchPlaceholder}
                            value={this.state.searchQuery}
                            onChange={(event) => this.setState({ searchQuery: event.target.value })}
                            className={'vertical-margin-2'}
                        />
                        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                            {filteredLanguages.map((lang) => (
                                <div
                                    key={lang.value}
                                    className={'bordered rounded touchable standard-padding-2 vertical-padding-2 vertical-margin'}
                                    onClick={() => this.handleLanguageSelect(lang)}
                                >
                                    {lang.label}
                                </div>
                            ))}
                            {filteredLanguages.length === 0 &&
                                <p style={{ textAlign: 'center' }}><CustomTranslation value={'KEY.No results'} /></p>
                            }
                        </div>
                        <div className={'vertical-margin-2'}>
                            <CustomCheckBox
                                label={<CustomTranslation value={'KEY.Remember choice'} />}
                                value={this.state.rememberChoice}
                                onValueChange={(value) => this.setState({ rememberChoice: value })}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant={'dark'} onClick={this.handleClose}>
                            <CustomTranslation value={'KEY.Cancel'} />
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

//export
export default TranslationButton;
